import React, { createContext, useContext } from "react";
import useOciIpHook from "../../../hooks/Dashboard/oci/useIp";

export const OciIpContext = createContext();

export const OciIpProvider = ({ children }) => {
  const data = useOciIpHook();
  return <OciIpContext.Provider value={data}>{children}</OciIpContext.Provider>;
};

export const useOciIp = () => useContext(OciIpContext);
